import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import { Link } from 'react-router-dom'
import Img1 from '../assets/images/why-dubai/Img1.webp'
import Img3 from '../assets/images/why-dubai/Img3.webp'
import Img4 from '../assets/images/why-dubai/Img4.webp'
import Img5 from '../assets/images/why-dubai/Img5.webp'
import Img6 from '../assets/images/why-dubai/Img6.webp'
import Img7 from '../assets/images/why-dubai/Img7.webp'
import { CheckLg } from 'react-bootstrap-icons'
import BannerImg from '../assets/images/why-dubai/BannerWhy.webp'
import CountUp from 'react-countup'
import ScrollTrigger from 'react-scroll-trigger'
import BgMiddle from '../assets/images/why-dubai/Img2.webp'
import axios from 'axios'

const WhyDubai = () => {
    const [counterOn, setCounterOn] = useState(false)
    const [transactionData, setTransactionData] = useState()

    useEffect(() => {
        window.scrollTo(0, 0)
        fetchTransactionData()
    }, [])

    const fetchTransactionData = async () => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/transaction`)
            setTransactionData(data.result)
        } catch (error) {
            console.error('transaction data', error)
        }
    }

    const countDecimals = (value) => {
        if (!value) return 0
        const parts = value.toString().split('.')
        return parts.length > 1 ? parts[1].length : 0
    }

    const tDecimals = countDecimals(transactionData?.transaction)
    const pDecimals = countDecimals(transactionData?.property_sale)
    const uDecimals = countDecimals(transactionData?.unit_sold)
    
    // Initialize counter values
    const transactionVal = parseFloat(transactionData?.transaction) || 0
    const propertySaleVal = parseFloat(transactionData?.property_sale) || 0
    const unitSoldVal = parseFloat(transactionData?.unit_sold) || 0

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title> Why Dubai? | Invest in the Fastest-Growing Property Market with 800 Homes </title>
                <meta
                    name="description"
                    content="Find out why Dubai is the best choice to invest in real estate. 800 Homes explains the tax advantages, high ROI, and investor-friendly policies to invest in dubai real estate."
                />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Why Dubai? | Invest in the Fastest-Growing Property Market with 800 Homes"
                />
                <meta
                    property="og:description"
                    content="Find out why Dubai is the best choice to invest in real estate. 800 Homes explains the tax advantages, high ROI, and investor-friendly policies to invest in dubai real estate."
                />
                <meta property="og:site_name" content="800homes" />
                <meta property="og:image" content="https://800homes.ae/og.webp" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:image:secure_url" content="https://800homes.ae/og.webp" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:description"
                    content="Find out why Dubai is the best choice to invest in real estate. 800 Homes explains the tax advantages, high ROI, and investor-friendly policies to invest in dubai real estate."
                />
                <meta
                    name="twitter:title"
                    content="Why Dubai? | Invest in the Fastest-Growing Property Market with 800 Homes"
                />
                <meta name="twitter:image" content="https://800homes.ae/og.webp" />
            </Helmet>

            <section id="website-responsive" className="container-fluid px-0">
                <section
                    id="website-responsive"
                    className="container-fluid bg-common-banner bg-home vh-100 px-0"
                    style={{ backgroundImage: `url(${BannerImg})` }}
                >
                    <Header />
                    <div className="py-md-5 mt-5 my-md-4" />
                    <div id="common-banner" className="col-10 mx-auto ps-md-3">
                        <h1 className="fw-500 text-white fs-home-banner text-uppercase lh-sm">
                            The Ultimate Destination
                            <br className="" />
                            for Luxury Living
                        </h1>
                        <h2 className="text-white fs-sub-home-banner fw-400 pt-2 pt-md-3">Where Dreams Meet Reality</h2>
                    </div>
                </section>

                <section className="py-md-5 py-4" />

                <section className="container-fluid">
                    <div className="row justify-content-center align-items-center gy-5">
                        <div className="col-11 col-md-5">
                            <h2 className="fs-ss-30 fw-600 text-white pb-4">
                                Why Choose Dubai for <br className="d-none d-md-block" /> Your Next Home?
                            </h2>

                            <div className="pb-4 text-white fs-ss-18 fw-300 col-md-10 lh-1-7em">
                                Whether you're drawn to a luxurious lifestyle, dynamic business environment, or cultural
                                diversity, there is something to offer for everyone. Real estate brokers in Dubai help
                                you find the right property tailored to your needs and preferences. With no personal
                                income tax, a stable economy, and a focus on sustainable growth, it is an ideal place to
                                call home.
                            </div>
                            <div className="text-white fs-ss-18 fw-400">
                                <Link
                                    to="/contact-us"
                                    className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                                >
                                    Inquire Now
                                </Link>
                            </div>
                        </div>
                        <div className="col-11 col-md-5 px-0">
                            <img
                                src={Img1}
                                className="w-100"

                                alt="Dubai cityscape and real estate overview"
                            />
                        </div>
                    </div>
                </section>

                <section className="py-md-5 py-4" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0" />

        <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
          <section id="numbers" className="container-lg">
            <div className="row justify-content-center text-center px-md-5 gy-4">
              <h2 className="pb-2 pb-md-4 text-white fs-ss-35 fw-500">
                Dubai Real Estate Transactions
              </h2>

              <div className="col-md border-white border-end border-1">
                <div className="fs-ss-40 text-ss-primary fw-600">
                  {counterOn && (
                    <CountUp start={0} end={transactionVal} decimals={tDecimals} duration={4} delay={0} />
                  )}
                  {transactionData?.transaction_unit ? ` ${transactionData.transaction_unit}` : ''}
                </div>
                <div className="fs-ss-18 text-white">
                  {`Total Transactions in ${transactionData?.transaction_month || ''}, ${new Date().getFullYear()}`}
                </div>
              </div>

              <div className="col-md border-white border-end border-1">
                <div className="fs-ss-40 text-ss-primary fw-600">
                  {counterOn && (
                    <CountUp start={0} end={propertySaleVal} decimals={pDecimals} duration={4} delay={0} />
                  )}
                  {transactionData?.property_sale_unit ? ` ${transactionData.property_sale_unit}` : ''}
                </div>
                <div className="fs-ss-18 text-white">
                  {`Property Sales in ${transactionData?.transaction_month || ''}, ${new Date().getFullYear()}`}
                </div>
              </div>

              <div className="col-md">
                <div className="fs-ss-40 text-ss-primary fw-600">
                  {counterOn && (
                    <CountUp start={0} end={unitSoldVal} decimals={uDecimals} duration={4} delay={0} />
                  )}
                  {transactionData?.unit_sold_unit ? ` ${transactionData.unit_sold_unit}` : ''}
                </div>
                <div className="fs-ss-18 text-white">
                  {`Units Sold in ${transactionData?.transaction_month || ''}, ${new Date().getFullYear()}`}
                </div>
              </div>
            </div>
          </section>
        </ScrollTrigger>

        {/* <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
          <section id="numbers" className="container-lg">
            <div className="row justify-content-center text-center px-md-5 gy-4">
              <h2 className="pb-2 pb-md-4 text-white fs-ss-35 fw-500">
                Dubai Real Estate Transactions
              </h2>

              <div className="col-md border-white border-end border-1">
                <div className="fs-ss-40 text-ss-primary fw-600">
                  {counterOn && (
                    <CountUp start={0} end={215346} decimals={0} duration={4} delay={0} />
                  )}
               
                </div>
                <div className="fs-ss-18 text-white">
                  Total Transactions in 2025
                </div>
              </div>

              <div className="col-md">
                <div className="fs-ss-40 text-ss-primary fw-600">
                  {counterOn && (
                    <CountUp start={0} end={686.8} decimals={pDecimals} duration={4} delay={0} />
                  )}
                  B
                </div>
                <div className="fs-ss-18 text-white">
                  Property Sales in 2025
                </div>
              </div>
            </div>
          </section>
        </ScrollTrigger> */}

                <section className="py-md-5 py-4" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0" />

                <section
                    id="bg-middle-banner"
                    className="container-fluid bg-middle-banner py-5 bg-fixed"
                    style={{ backgroundImage: `url(${BgMiddle})` }}
                >
                    <div className="row justify-content-evenly py-md-5">
                        <div
                            className="col-11 col-md-6 mx-auto bg-middle-banner-color text-center p-5 my-md-5"

                        >
                            <h2 className="pb-2 text-white fs-ss-35 fw-600">Luxury at Every Corner</h2>
                            <div className="text-white fs-ss-22 fw-300 lh-1-7em">
                                Dubai is a city where luxury is a way of life. Every aspect of it radiates elegance,
                                from its stunning skyline to the stylish design of private homes. Imagine living in a
                                penthouse with panoramic city views or a villa with exclusive beaches.
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-md-5 py-4" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0" />

                <section className="container-fluid">
                    <div className="row justify-content-evenly align-items-center gy-5">
                        <div className="col-11 col-md-5 px-0 d-none d-md-block">
                            <img src={Img3} className="w-100" alt="Dubai prime real estate market" />
                        </div>
                        <div className="col-11 col-md-5">
                            <h2 className="fs-ss-30 fw-600 text-white pb-4">
                                Prime Real Estate Market
                            </h2>
                            <div className="pb-4 text-white fs-ss-18 fw-300 col-md-10 lh-1-7em">
                                <div className="d-flex pb-2 pb-md-3">
                                    <div className="">
                                        <CheckLg className="fs-ss-30 text-ss-primary me-3" />
                                    </div>
                                    <div className="lh-1-7em">High ROI Potential</div>
                                </div>

                                <div className="d-flex pb-2 pb-md-3">
                                    <div className="">
                                        <CheckLg className="fs-ss-30 text-ss-primary me-3" />
                                    </div>
                                    <div className="lh-1-7em">Global Business Hub</div>
                                </div>

                                <div className="d-flex pb-2 pb-md-3">
                                    <div className="">
                                        <CheckLg className="fs-ss-30 text-ss-primary me-3" />
                                    </div>
                                    <div className="lh-1-7em">200+ Nationalities</div>
                                </div>

                                <div className="d-flex pb-2 pb-md-3">
                                    <div className="">
                                        <CheckLg className="fs-ss-30 text-ss-primary me-3" />
                                    </div>
                                    <div className="lh-1-7em">#1 in MENA for Real Estate</div>
                                </div>
                            </div>
                            <div className="text-white fs-ss-18 fw-400">
                                <Link
                                    to="/contact-us"
                                    className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                                >
                                    Get in Touch
                                </Link>
                            </div>
                        </div>
                        <div className="col-11 col-md-5 px-0 d-block d-md-none">
                            <img
                                src={Img3}
                                className="w-100"

                                alt="Dubai strategic location advantages"
                            />
                        </div>
                    </div>
                </section>

                <section className="py-md-5 py-4 my-md-2" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0" />

                <section className="container-fluid">
                    <div className="row justify-content-evenly gy-4 text-md-center">
                        <div className="col-11 col-md-12">
                            <h2 className="fs-ss-30 fw-600 text-white pb-3">
                                Exclusive Perks
                            </h2>
                            <div className=" text-white fs-ss-18 lh-1-7em fw-300 col-md-8 mx-auto">
                                Living in this city means enjoying many exclusive benefits. The city is renowned for its
                                luxury shopping destinations, which host over 1,200 stores. Moreover, its strategic
                                location offers easy travel to other European, Asian, and African luxury destinations.
                                Along with consistently ranking among the top cities worldwide for its exceptional
                                infrastructure, its appeal as a top destination for luxury living is unsurpassable.
                            </div>
                            <div className="pt-4 text-white fs-ss-18 fw-400">
                                <Link
                                    to="/contact-us"
                                    className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                                >
                                    Inquire Now
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-md-5 py-4 my-md-2" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0" />

                <section className="container-fluid">
                    <div className="row justify-content-center align-items-center gy-4">
                        <div className="col-11 col-md-4 px-0 pb-4 pb-md-0">
                            <div className="col-11 col-md-10 ms-md-auto mx-auto">
                                <h2 className="fs-ss-48 fw-600 text-white pb-4 lh-sm">
                                    A Safe and <br className="d-none d-md-block" /> Family-Friendly Environment
                                </h2>
                                <div className="pb-md-4 text-white fs-ss-18 fw-300 lh-1-7em">
                                    Renowned for luxury, this city is equally committed to providing a safe,
                                    family-oriented atmosphere. Consistently ranked among the safest in the world, it
                                    offers families unmatched security and peace of mind. With excellent schools, parks,
                                    and recreational facilities, it's an ideal place for families to thrive.
                                </div>
                            </div>
                        </div>
                        <div className="col-11 col-md-6">
                            <div className="row justify-content-center gy-4 px-1">
                                <div className="col-6 col-md-5 ">
                                    <img src={Img4} className="w-100" alt="Dubai economic stability" />
                                </div>

                                <div className="col-6 col-md-5 ">
                                    <img src={Img5} className="w-100" alt="Dubai investment security" />
                                </div>

                                <div className="col-6 col-md-5 ">
                                    <img src={Img6} className="w-100" alt="Dubai tax benefits" />
                                </div>

                                <div className="col-6 col-md-5 ">
                                    <img src={Img7} className="w-100" alt="Dubai lifestyle and luxury" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-md-5 py-4" />

                <Footer />
            </section>
        </>
    )
}

export default WhyDubai
